var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalFan2Variable = function SvgDAhuSignalFan2Variable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 105,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,95c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S425.5,95,431,95 M431,94c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S437.1,94,431,94L431,94z",
    fill: "#1C9D5B"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "426.3,110 435.6,100.7 434.9,100 425.6,109.3 425.6,98.7 424.6,98.7 424.6,111 436.9,111 436.9,110"
  })))));
};
export default SvgDAhuSignalFan2Variable;